export default __webpack_public_path__ + "static/media/7a7023f8c3c74cc8528aca8acabfc51f.svg";